module.exports = __webpack_public_path__ + "img/isntree.cdfc5226.svg";